import React, { useRef, useEffect } from 'react';
import { useLocation, Switch } from 'react-router-dom';
import AppRoute from './utils/AppRoute';
import ScrollReveal from './utils/ScrollReveal';
import ReactGA from 'react-ga';
import './App.css'
import ReactDOM from "react-dom";

// Layouts
import LayoutDefault from './layouts/LayoutDefault';

// Upload Files
import UploadIPFS from './components/files/UploadIPFS'

// Views 
import Home from './views/Home';
import AppPortal from './views/AppPortal';

// Experiences
import Box from'./components/experiences/Box'
import Gltf from './components/experiences/Gltf'

// Initialize Google Analytics
ReactGA.initialize(process.env.REACT_APP_GA_CODE);

const trackPage = page => {
  ReactGA.set({ page });
  ReactGA.pageview(page);
};

const App = () => {

  const childRef = useRef();
  let location = useLocation();

  useEffect(() => {
    const page = location.pathname;
    document.body.classList.add('is-loaded')
    childRef.current.init();
    trackPage(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]); 

  return (
    <ScrollReveal
      ref={childRef}
      children={() => (
        <Switch>
          <AppRoute exact path="/" component={AppPortal}/>
          <AppRoute exact path="/app" component={AppPortal}/>
          <AppRoute exact path="/experiences" component={Box}/>
          <AppRoute exact path="/upload" component={UploadIPFS}/>
        </Switch>
      )} />
  );
}

export default App;